// extracted by mini-css-extract-plugin
export default {"editableTable":"editable-table_editableTable__-ifrX","card":"editable-table_card__MX8B6","table":"editable-table_table__4khvy"};